var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinterCrossed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    d: "M2.8016 2.7999c0-.7722.6278-1.4 1.4-1.4h4.959c.3719 0 .7285.1466.991.409l.6409.641c.2625.2625.4091.619.4091.991v1.459h-1.4v-1.459l-.641-.641h-4.959v2.1h-.7354l-.6646-.5198zm-.2102 2.8157C1.9186 5.7173 1.4016 6.2991 1.4016 7v2.1c0 .3872.3128.7.7.7h.7v1.4c0 .7722.6278 1.4 1.4 1.4h5.6a1.398 1.398 0 0 0 1.0763-.5054L9.7337 11.2H4.2016V9.1h2.8462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    fillRule: "evenodd",
    d: "M9.8016 9.8552v-.7553H8.836l-4.4749-3.5h6.8405c.7721 0 1.4.6278 1.4 1.4v2.1c0 .3872-.3129.7-.7.7h-.7v1.1499zm1.4212-2.8765a.5251.5251 0 1 0-.7425.7426.5251.5251 0 0 0 .7425-.7426",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    d: "M.4577 1.9412c.1704-.2161.4842-.2556.7003-.0852l12.3023 9.6423c.2161.1704.2556.4842.0852.7003s-.4842.2557-.7004.0853L.5429 2.6415c-.2162-.1704-.2556-.4842-.0852-.7003"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinterCrossed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/printer-crossed.c86206627193d53a8b6517633f39e50e.svg";